export class FaqAccordion {
  constructor() {
    this.items = [];
    this.init();
  }

  init() {
    this.items = [...document.querySelectorAll('.l-faq__item')].map((item) => ({
      item,
      btn: item.querySelector('.l-faq__question'),
      content: item.querySelector('.l-faq__answer'),
    }));
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.items.forEach((entry) => {
      const { btn, content } = entry;

      if (!btn || !content) return;

      btn.addEventListener('click', () => this.toggleAccordion(entry));
    });
  }

  toggleAccordion(entry) {
    const isActive = entry.item.classList.contains('is-active');
    isActive ? this.closeItem(entry) : this.openItem(entry);
  }

  openItem({ item, btn, content }) {
    item.classList.add('is-active');
    btn.setAttribute('aria-expanded', 'true');
    content.setAttribute('aria-hidden', 'false');
  }

  closeItem({ item, btn, content }) {
    item.classList.remove('is-active');
    btn.setAttribute('aria-expanded', 'false');
    content.setAttribute('aria-hidden', 'true');
  }
}
